import { fetchApi } from "../fetchApi";

export async function callButton({ context, company_id, model, productId }) {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args: [[productId]],
      kwargs: {
        context: {
          allowed_company_ids: [company_id],
          lang: context.lang,
          params: {
            cids: company_id,
            id: productId,
            model,
            view_type: "form",
          },
          search_default_published: 1,
          tz: context.tz,
          uid: context.uid,
        },
      },
      method: "display_social_media_wizard",
      model: model,
    },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };
  return fetchApi({ requestOptions, endpoint: "/web/dataset/call_button" });
}
